import {
  getPublicControllerGetMeQueryKey,
  getUserControllerGetMyUserDataQueryKey,
  usePublicControllerGetMe,
  useUserControllerGetMyUserData,
} from '@safc/api-client';
import { useContext } from 'react';

import {
  AbilityContext,
  updatePermissions,
} from './permissions/usePermissions.js';
import { useCurrentCompany } from './useCurrentCompany.js';

export const useMyUser = () => {
  const ability = useContext(AbilityContext);
  const { companyId } = useCurrentCompany();

  const {
    data: user,
    isLoading,
    error,
  } = useUserControllerGetMyUserData({
    query: { queryKey: getUserControllerGetMyUserDataQueryKey() },
  });

  if (user && companyId) {
    updatePermissions(ability, user, companyId);
  }

  return {
    user,
    isLoggedIn: Boolean(user?.email),
    isLoading,
    error,
  };
};

export const useMaybeMyUser = () => {
  const {
    data: user,
    isLoading,
    error,
  } = usePublicControllerGetMe({
    query: { queryKey: getPublicControllerGetMeQueryKey() },
  });

  return {
    user,
    isLoading,
    error,
  };
};
